var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "hru-home-section" }, [
      _c(
        "div",
        { class: _vm.sidemenuClass, attrs: { "data-mcs-theme": "minimal" } },
        [
          _c(
            "div",
            { class: "sidemenu-container " + _vm.sideMenuContainerClass },
            [
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "ViewLocationDepartments",
                          params: { slug: _vm.extension_slug }
                        },
                        title: "Company Directory"
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/company-directory.png" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [
                        _vm._v("Company Directory")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.userPermissions.indexOf("can_access_manager_directory") > -1
                ? [
                    _c(
                      "div",
                      { staticClass: "sidemenu-list" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { name: "ManagerDirectory" },
                              title: "Manager Directory"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/static/images/company-directory.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "mrtop" }, [
                              _vm._v("Manager Directory")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.roleId <= 2
                ? [
                    _c(
                      "div",
                      { staticClass: "sidemenu-list" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { path: "/leadershipdevelopment" },
                              title: "Leadership and Development"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/images/updated-leadership-and-development.png"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("Leadership and"),
                              _c("br"),
                              _vm._v(
                                "\n                                    Development"
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "HrCalendar" },
                        title: "HR Calendar"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/updated-hr-calendar-img.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [
                        _vm._v("HR Calendar")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/erg" },
                        title: "Employee Resource Group"
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/updated-surveys.png" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [
                        _vm._v("Employee Resource Group")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/surveys" }, title: "Surveys" } },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/updated-surveys.png" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [_vm._v("Surveys")])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/employeerecognition" },
                        title: "Employee Recognition"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/updated-employee-recognition.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Employee"),
                        _c("br"),
                        _vm._v("\n                                Recognition")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/employeeperksprogram" },
                        title: "Employee Perks"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/updated-employee-perks.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Employee"),
                        _c("br"),
                        _vm._v("\n                                Perks")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/wellness" },
                        title: "Employee Wellness"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/updated-employee-wellness.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Employee"),
                        _c("br"),
                        _vm._v("\n                                Wellness")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { path: "/benefits" },
                        title: "Employee Benefits"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/updated-employee-benefits.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Employee"),
                        _c("br"),
                        _vm._v("\n                                Benefits")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { path: "/401kplan" }, title: "Retirement" }
                    },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/updated-retirement.png" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [
                        _vm._v("Retirement")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidemenu-list" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/gallery" }, title: "Gallery" } },
                    [
                      _c("img", {
                        attrs: { src: "/static/images/updated-gallery.png" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mrtop" }, [_vm._v("Gallery")])
                    ]
                  )
                ],
                1
              )
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "slider-home col-12" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("h2", [_vm._v(" Meet the HR Team ")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "hr-team-main-section col-12 float-l" },
              [
                _vm.windowWidth >= 992
                  ? [
                      _c(
                        "div",
                        { class: "row " + _vm.hrContainerClass },
                        [
                          _vm._l(_vm.hrTeamList, function(text, index) {
                            return [
                              _vm.inFirstRow >= index + 1 &&
                              _vm.windowWidth >= 992
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "hover-home-eefect" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "member-img-hover"
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        path:
                                                          "/meethrteam/" +
                                                          text.id
                                                      }
                                                    }
                                                  },
                                                  [
                                                    text.profile_image == ""
                                                      ? [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/default.jpg",
                                                              alt:
                                                                text.first_name +
                                                                " " +
                                                                text.last_name
                                                            }
                                                          })
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                text.profile_image,
                                                              alt:
                                                                text.first_name +
                                                                " " +
                                                                text.last_name
                                                            }
                                                          })
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "team-name" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(text.first_name) +
                                                      " " +
                                                      _vm._s(text.last_name) +
                                                      " "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        " "
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "team-designation"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        text.team_designation
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: "row " + _vm.hrContainerClass },
                        [
                          _vm._l(_vm.hrTeamList, function(text, index) {
                            return [
                              _vm.inFirstRow < index + 1 &&
                              _vm.windowWidth >= 992
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "hover-home-eefect" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "member-img-hover"
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        path:
                                                          "/meethrteam/" +
                                                          text.id
                                                      }
                                                    }
                                                  },
                                                  [
                                                    text.profile_image == ""
                                                      ? [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/default.jpg",
                                                              alt:
                                                                text.first_name +
                                                                " " +
                                                                text.last_name
                                                            }
                                                          })
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                text.profile_image,
                                                              alt:
                                                                text.first_name +
                                                                " " +
                                                                text.last_name
                                                            }
                                                          })
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "team-name" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(text.first_name) +
                                                      " " +
                                                      _vm._s(text.last_name) +
                                                      " "
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        " "
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "team-designation"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        text.team_designation
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ]
                  : [
                      _c(
                        "div",
                        { class: "row " + _vm.hrContainerClass },
                        [
                          _vm._l(_vm.hrTeamList, function(text, index) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "hover-home-eefect" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "member-img-hover" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  path: "/meethrteam/" + text.id
                                                }
                                              }
                                            },
                                            [
                                              text.profile_image == ""
                                                ? [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/images/default.jpg",
                                                        alt:
                                                          text.first_name +
                                                          " " +
                                                          text.last_name
                                                      }
                                                    })
                                                  ]
                                                : [
                                                    _c("img", {
                                                      attrs: {
                                                        src: text.profile_image,
                                                        alt:
                                                          text.first_name +
                                                          " " +
                                                          text.last_name
                                                      }
                                                    })
                                                  ]
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "team-name" }, [
                                        _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(text.first_name) +
                                              " " +
                                              _vm._s(text.last_name) +
                                              " "
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(text.post) + " "
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "team-designation" },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(text.team_designation) +
                                                " "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("section", { staticClass: "hru-udated-page-slider" }, [
      _c("span", [_vm._v("A Great Place to Work!")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "carousel slide",
          attrs: { id: "carousel-example-generic", "data-ride": "carousel" }
        },
        [
          _c(
            "ol",
            { staticClass: "carousel-indicators" },
            [
              _vm._l(_vm.imageList, function(images, index) {
                return [
                  index == 0
                    ? [
                        _c("li", {
                          staticClass: "active",
                          attrs: {
                            "data-target": "#carousel-example-generic",
                            "data-slide-to": index
                          }
                        })
                      ]
                    : [
                        _c("li", {
                          attrs: {
                            "data-target": "#carousel-example-generic",
                            "data-slide-to": index
                          }
                        })
                      ]
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "carousel-inner", attrs: { role: "listbox" } },
            [
              _vm._l(_vm.imageList, function(images, index) {
                return [
                  index == 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "item active" },
                          [
                            _vm._l(images, function(image, index_child) {
                              return [
                                image.type == "image"
                                  ? [
                                      _c("img", {
                                        staticClass: "pull-left",
                                        attrs: {
                                          src: image.image,
                                          alt: "Index is zero " + image.type
                                        }
                                      })
                                    ]
                                  : [
                                      image.video != ""
                                        ? _c(
                                            "video",
                                            {
                                              staticClass: "pull-left",
                                              attrs: {
                                                controls: "controls",
                                                preload: "metadata"
                                              }
                                            },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: image.video + "#t=0.5",
                                                  type: "video/mp4"
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      image.video_url != ""
                                        ? _c("iframe", {
                                            staticClass: "pull-left",
                                            attrs: {
                                              src: image.video_url,
                                              controls: "",
                                              allowfullscreen: "",
                                              autostart: "0"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _vm._l(images, function(image, index_child) {
                              return [
                                image.type == "image"
                                  ? [
                                      _c("img", {
                                        staticClass: "pull-left",
                                        attrs: {
                                          src: image.image,
                                          alt: "Index not zero " + image.type
                                        }
                                      })
                                    ]
                                  : [
                                      image.video != ""
                                        ? _c(
                                            "video",
                                            {
                                              staticClass: "pull-left",
                                              attrs: {
                                                controls: "controls",
                                                preload: "metadata"
                                              }
                                            },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: image.video + "#t=0.5",
                                                  type: image.media_type
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      image.video_url != ""
                                        ? _c("iframe", {
                                            staticClass: "pull-left",
                                            attrs: {
                                              src: image.video_url,
                                              controls: "",
                                              allowfullscreen: "",
                                              autostart: "0"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                              ]
                            })
                          ],
                          2
                        )
                      ]
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "hru-updated-view-banner accordion",
        attrs: { id: "accordionExample" }
      },
      [
        _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sliderCount > 0,
                expression: "sliderCount > 0"
              }
            ],
            attrs: { href: "", id: "BannerButtonTitle" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleBanner()
              }
            }
          },
          [_vm._v("View Banner")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticStyle: { display: "none" },
            attrs: {
              id: "BannerButton",
              "data-toggle": "collapse",
              "data-target": "#collapseBanner",
              "aria-expanded": "false",
              "aria-controls": "collapseBanner"
            }
          },
          [_vm._v("\n                View Banner\n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse",
            attrs: {
              id: "collapseBanner",
              "aria-labelledby": "collapseBanner",
              "data-parent": "#accordionExample"
            }
          },
          [
            _c("app-slider", {
              key: _vm.sliderType.location_type,
              attrs: { sliderType: _vm.sliderType }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("section", { staticClass: "hru-updated-insta-photo-container" }, [
      _c(
        "div",
        { staticClass: "hru-updated-upload-photo-container" },
        [
          _c("span", [_vm._v("Upload Photos")]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { name: "AddPhoto" } } }, [
            _c("img", { attrs: { src: "/static/images/uploadicon.png" } })
          ]),
          _vm._v(" "),
          _vm._m(4)
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "hru-updated-instragram-container" }, [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 float-left", attrs: { id: "list" } },
          [
            _c(
              "div",
              { staticClass: "list-group", attrs: { id: "list" } },
              [
                _vm.events.length > 0
                  ? [
                      _vm._l(_vm.events, function(text, index) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass:
                                "list-group-item list-group-item-action",
                              attrs: { type: "button" }
                            },
                            [
                              _vm._v(_vm._s(text.title)),
                              _c("br"),
                              _c(
                                "span",
                                { staticClass: "home-page-event-time" },
                                [_vm._v(_vm._s(text.eventdate))]
                              )
                            ]
                          )
                        ]
                      })
                    ]
                  : [_vm._m(6)]
              ],
              2
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "hru-updated-social-container hover14" },
      [
        _c("span", [_vm._v("We’re Social")]),
        _vm._v(" "),
        _vm._l(_vm.socialMediaLinks, function(social, index) {
          return [
            social.social_title.value == "facebook"
              ? [
                  _c(
                    "a",
                    { attrs: { href: social.social_value, target: "_blank" } },
                    [_vm._m(7, true)]
                  )
                ]
              : social.social_title.value == "instagram"
              ? [
                  _c(
                    "a",
                    { attrs: { href: social.social_value, target: "_blank" } },
                    [_vm._m(8, true)]
                  )
                ]
              : social.social_title.value == "linkedin"
              ? [
                  _c(
                    "a",
                    { attrs: { href: social.social_value, target: "_blank" } },
                    [_vm._m(9, true)]
                  )
                ]
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vvg-svt-container" }, [
      _c("div", { staticClass: "vvg-svt-left-container" }, [
        _c("div", { staticClass: "vvg-svt-text" }, [
          _c("span", [_vm._v("Our companies run on the 3 pillars of")])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: "/static/images/svt-graphics.png",
            alt: "Speed, Value & Trust"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vvg-svt-right-container" }, [
        _c("div", { staticClass: "vvg-svt-block" }, [
          _c("div", { staticClass: "vvg-svt-block-text" }, [
            _c("h3", [_vm._v("Speed")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "We focus on accelerating your career by planning for the future"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "vvg-svt-block" }, [
          _c("div", { staticClass: "vvg-svt-block-text" }, [
            _c("h3", [_vm._v("Value")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("We value our team members and consider them family")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "vvg-svt-block vvg-svt-block0" }, [
          _c("div", { staticClass: "vvg-svt-block-text" }, [
            _c("h3", [_vm._v("Trust")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Every good relationship begins with trust, mutual respect and open communication"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ethics-hotline" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("p", [
              _vm._v(
                '\n\n                            "At Velocity Vehicle Group and our affiliated companies, we are committed to doing business ethically, with integrity, and in compliance with the law. We can only achieve this commitment if we are all confident we can speak up with questions, concerns, or suggestions. We hope that you are all comfortable speaking directly with me, HR, or your manager, but in those cases when you are not, please use this Speak Up Line to contact us about your questions, concerns, or suggestions. We value your opinion and want to hear from you!"\n                        '
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "speakup-wrapper" }, [
              _c("p", { staticClass: "click-content" }, [
                _vm._v(
                  "\n                                Click here to make a confidential report >\n                            "
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://secure.ethicspoint.com/domain/media/en/gui/92280/index.html"
                  }
                },
                [
                  _c("img", {
                    staticClass: "speakup-image",
                    attrs: { src: "/static/images/speak_up_line.png" }
                  })
                ]
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "left carousel-control",
        attrs: {
          href: "#carousel-example-generic",
          role: "button",
          "data-slide": "prev"
        }
      },
      [
        _c("span", {
          staticClass: "glyphicon glyphicon-chevron-left",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "right carousel-control",
        attrs: {
          href: "#carousel-example-generic",
          role: "button",
          "data-slide": "next"
        }
      },
      [
        _c("span", {
          staticClass: "glyphicon glyphicon-chevron-right",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("Next")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Click on the button to upload photos."),
      _c("br"),
      _vm._v("\n                    Share the images with us to "),
      _c("br"),
      _vm._v("\n                    showcase in gallery.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 float-left" }, [
      _c("iframe", {
        staticStyle: { border: "none", overflow: "hidden" },
        attrs: {
          src:
            "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FVelocityVehicleGroup%2F&tabs=timeline&width=380&height=570&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
          width: "380",
          height: "570",
          scrolling: "no",
          frameborder: "0",
          allowTransparency: "true",
          allow: "encrypted-media"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "no-events" }, [
      _vm._v("No Events "),
      _c("br"),
      _vm._v("Available")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: "/static/images/facebookicon.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: "/static/images/instagramicon.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: "/static/images/linkedinicon.png" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 